import React, { useState } from 'react';
import './AndroidMobileVersion.css';
import androidAppImage from './assets/rust script android app.png';
import androidTabletImage from './assets/android tablet.png';
import makcuBoardImage from './assets/makcu board.png';
import { FaAndroid, FaDesktop } from 'react-icons/fa';
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { LiaMicrochipSolid } from "react-icons/lia";

const AndroidMobileVersion = () => {
  const [tiltX, setTiltX] = useState(0);
  const [tiltY, setTiltY] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    window.location.href = "#pricing";
  };

  const handleMouseMove = (e) => {
    if (!isHovered) return;
    
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const tiltAmountX = ((x - centerX) / centerX) * -25; // -25 to 25 degrees, inverted
    const tiltAmountY = ((y - centerY) / centerY) * -20; // -20 to 20 degrees, inverted
    setTiltX(tiltAmountX);
    setTiltY(tiltAmountY);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setTiltX(0);
    setTiltY(0);
  };

  return (
    <div 
      className="android-mobile-version" 
      onClick={handleClick}
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        '--tilt-x': `${tiltX}deg`,
        '--tilt-y': `${tiltY}deg`
      }}
    >
      <span className="android-new-tag">NEW</span>
      <div className="android-left">
        <img 
          src={androidTabletImage} 
          alt="EAGLE SCRIPT for Android Tablet - Rust No Recoil Mobile Version"
          className="android-tablet"
          onClick={() => window.location.href = "#pricing"}
          loading="lazy"
        />
        <img 
          src={makcuBoardImage} 
          alt="MAKCU Board - Hardware Support for EAGLE SCRIPT"
          className="android-makcu"
          onClick={() => window.location.href = "#pricing"}
          loading="lazy"
        />
        <img 
          src={androidAppImage} 
          alt="EAGLE SCRIPT Android Mobile App - Rust Script for Smartphones"
          className="android-phone"
          onClick={() => window.location.href = "#pricing"}
          loading="lazy"
        />
      </div>
      <div className="android-right">
        <h2>NOW available for Smartphone & Tablet!</h2>
        <p className="android-description">
          Your <span className="android-highlight">Android Smartphone</span> or <span className="android-highlight">Tablet</span> runs the EAGLE Rust Script as an App.
        </p>
        <p className="android-all-features">
          <RiVerifiedBadgeFill /> All Features from the PC Version.
        </p>
        <ul className="android-features">
          <li className="android-feature-item">
            <span className="android-icon-wrapper"><FaAndroid /></span>
            Android Device
          </li>
          <li className="android-feature-item">
            <span className="android-icon-wrapper android-makcu-icon"><LiaMicrochipSolid /></span>
            MAKCU
          </li>
          <li className="android-feature-item">
            <span className="android-icon-wrapper"><FaDesktop /></span>
            Your PC
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AndroidMobileVersion;
